module.exports = __webpack_public_path__ + "static/media/careers-page-grid4.768da50f.png";